<template>
  <v-container>
    <v-alert variant="outlined" type="warning" prominent border="top">
      Failed to load component. Please check your internet connection. And try to refresh.
    </v-alert>
  </v-container>
</template>
